module.exports = __webpack_public_path__ + "img/max-file-edit--csv.7b7c3f4f.svg";